import { MDBSpinner } from "mdbreact";
import React from "react";
import styles from "./styles.module.scss";

const MDLoading = () => {
  return (
    <div className={styles.loading}>
      <MDBSpinner big crazy tag="div" />
    </div>
  );
};

export default MDLoading;
